module.exports = __webpack_public_path__ + "img/porsche-interauto.a176d7f.svg";